export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14620.107ebde9.jpg";